import { render, staticRenderFns } from "./print-review-ticket.vue?vue&type=template&id=744f1d31&"
import script from "./print-review-ticket.vue?vue&type=script&lang=js&"
export * from "./print-review-ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports